import { render, staticRenderFns } from "./ticketStatistics.vue?vue&type=template&id=0bdbe47c"
import script from "./ticketStatistics.vue?vue&type=script&lang=js"
export * from "./ticketStatistics.vue?vue&type=script&lang=js"
import style0 from "./ticketStatistics.vue?vue&type=style&index=0&id=0bdbe47c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports